/**
 * Chair Dinkum - Gas Lift Page Add-on
 * Offers the unblocking tool as an optional add-on on /products/hag-capisco-gas-lift.
 * PARTS1 (18 Oct 2026): price and availability are read live from the tool's product JSON
 * (was hard-coded at $45 while the tool sells at $85), copy per owner 18 Oct 2026: "Required to remove your old gas lift."
 */
(function() {
  'use strict';

  if (window.location.pathname.indexOf('/products/hag-capisco-gas-lift') === -1) return;

  var TOOL_HANDLE = 'hag-gas-lift-unblocking-tool';
  var TOOL_VARIANT_ID = 42261680619575;

  function money(cents) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function build(form, variant) {
    var buyBtn = form.querySelector('[type="submit"], .btn--add-to-cart, .add-to-cart');

    var container = document.createElement('div');
    container.id = 'cd-gaslift-addon';
    container.style.cssText = 'margin:16px 0;padding:16px;border:1px solid #e8e8e8;border-radius:6px;';

    var label = document.createElement('label');
    label.style.cssText = 'display:flex;align-items:flex-start;gap:10px;cursor:pointer;';

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'cd-add-unblocking-tool';
    checkbox.style.cssText = 'margin-top:3px;width:18px;height:18px;flex-shrink:0;accent-color:#000;';

    var textWrap = document.createElement('div');
    textWrap.innerHTML = '<p style="margin:0;font-weight:500;font-size:0.9rem;">Add the HÅG Gas Lift Unblocking Tool (+' + money(variant.price) + ')</p>' +
      '<p style="margin:4px 0 0 0;font-size:0.8rem;color:#666;line-height:1.4;">Required to remove your old gas lift.</p>';

    label.appendChild(checkbox);
    label.appendChild(textWrap);
    container.appendChild(label);

    if (buyBtn && buyBtn.closest('.product-block')) {
      buyBtn.closest('.product-block').before(container);
    } else if (buyBtn) {
      buyBtn.parentElement.before(container);
    } else {
      form.appendChild(container);
    }

    form.addEventListener('submit', function(e) {
      if (!checkbox.checked) return;
      e.preventDefault();
      e.stopPropagation();
      var mainVariantInput = form.querySelector('select[name="id"], input[name="id"]');
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
      if (!mainVariantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [ { id: parseInt(mainVariantId, 10), quantity: 1 }, { id: TOOL_VARIANT_ID, quantity: 1 } ] })
      })
      .then(function(response) {
        if (response.ok) { window.location.href = '/cart'; }
        else { checkbox.checked = false; form.submit(); }
      })
      .catch(function() { checkbox.checked = false; form.submit(); });
    });
  }

  function init() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) { setTimeout(init, 500); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + TOOL_HANDLE + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants) return;
        var v = p.variants.filter(function(x) { return x.id === TOOL_VARIANT_ID; })[0];
        if (!v || !v.available) return; // never offer a tool we cannot sell, never show a stale price
        build(form, v);
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
